<template>
  <div class="homepage">
    <generic-big-text 
      :text="topText.text"
      :btn-text="topText.btnText"
      :btn-href="topText.btnHref"
      :btn-style="topText.btnStyle"
      :bg-style="topText.bgStyle"
      :text-color="topText.textColor"></generic-big-text>

    <div class="container" v-if="!!doubleImgWidget">
      <div class="doubleImgWidget imageWidgetWrapper">
        <double-img-widget 
          :key="doubleImgWidget.id"
          :title="doubleImgWidget.title"
          :sub-title="doubleImgWidget.subTitle"
          :images="doubleImgWidget.images"
          :logos="doubleImgWidget.logos"
          :cta-label="doubleImgWidget.ctaLabel"
          :cta-href="doubleImgWidget.ctaHref"
          :cta-text="doubleImgWidget.ctaText"></double-img-widget>
      </div>
    </div>
    
    <div class="container" v-if="!!bigCall">
      <div class="bigCall imageWidgetWrapper">
        <image-widget 
          :key="bigCall.id"
          :title="bigCall.title"
          :sub-title="bigCall.subTitle"
          :img="bigCall.img"
          :cta-href="bigCall.ctaHref"
          :cta-text="bigCall.ctaText"></image-widget>
      </div>
    </div>


    <div class="imageWidgetWrapper" v-if="!!imagesWidget.length">
      <gallery
        :conf="{
          prevNextButtons: false,
          pageDots: false,
          contain: true,
          wrapAround: imagesWidget.length > 2 ? true : false,
          cellAlign: 'left'
        }"
        :prev-style="{
          display: imagesWidget.length > 2 ? 'block' : 'none',
        }"
        :next-style="{
          display: imagesWidget.length > 2 ? 'block' : 'none',
        }">
        <div class="carousel-cell" v-for="image in imagesWidget">    
          <image-widget 
            :key="image.id"
            :title="image.title"
            :sub-title="image.subTitle"
            :img="image.img"
            :cta-href="image.ctaHref"
            :cta-text="image.ctaText"></image-widget>
        </div>
      </gallery>
    </div>

    <div class="sectionsWrapper">
      <div class="container">
        <h3 class="sectionsTitle" v-html="sectionsTitle"></h3>
        <div class="sections">
          <network-section
            v-for="section in sections"
            :id="section.id"
            :color="section.color"
            :num="section.num"
            :text="section.text"
            :key="section.id"></network-section>
        </div>
      </div>
    </div>

    <div class="bigBtnWrapper" style="padding-bottom:60px">
      <big-btn
        :color="bigBtn.color"
        :btn-href="bigBtn.btnHref"
        :btn-text="bigBtn.btnText"></big-btn>
    </div>

    <div class="storiesWrapper" v-if="!!imagesWidget.length">
      <div class="container">
        <h3 class="sectionsTitle" v-html="storiesTitle"></h3>
      </div>
      <div class="stories">
        <gallery
          :conf="{
            prevNextButtons: false,
            pageDots: false,
            contain: true,
            setGallerySize: false,
            watchCss: true,
            wrapAround: stories.length > 3 ? true : false,
            cellAlign: 'left'
          }"
          :prev-style="{
            display: stories.length > 3 ? 'block' : 'none',
          }"
          :next-style="{
            display: stories.length > 3 ? 'block' : 'none',
          }">
          <div class="carousel-cell" v-for="story in stories">    
            <story-widget
              :key="story.id"
              :title="story.title"
              :story-href="story.storyHref"
              :img="story.img"
              :authors="story.authors"></story-widget>
          </div>
        </gallery>
      </div>
    </div>

    <generic-big-text 
      :text="bottomText.text"
      :btn-text="bottomText.btnText"
      :btn-href="bottomText.btnHref"
      :btn-style="bottomText.btnStyle"
      :bg-style="bottomText.bgStyle"
      :text-color="bottomText.textColor"></generic-big-text>

    <div class="bottomTextWrapper">
      <div class="container">
        <network-description
          :network-logo="networkDescription.networkLogo"
          :network-name="networkDescription.networkName"
          :btn-href="networkDescription.btnHref"
          :btn-text="networkDescription.btnText"
          :text="networkDescription.text"></network-description>
      </div>
    </div>
  </div>
</template>

<script>

  import GenericBigText from './generic_big_text'
  import DoubleImgWidget from './double-img-widget'
  import ImageWidget from './image_widget'
  import NetworkSection from './network_section'
  import BigBtn from './big_btn'
  import StoryWidget from './story_widget'
  import NetworkDescription from './network_description'
  import Gallery from './gallery'

  export default {
    name: 'Homepage',
    components:{
      GenericBigText,
      ImageWidget,
      NetworkSection,
      BigBtn,
      StoryWidget,
      NetworkDescription,
      Gallery,
      DoubleImgWidget
    },

    data(){
      return {
      }
    },
    props: {
      stories: {
        type: Array,
        default: ()=>{}
      },
      doubleImgWidget: {
        type: Object,
        default: ()=>{}
      },
      bigCall: {
        type: Object,
        default: ()=>{}
      },
      imagesWidget: {
        type: Array,
        default: ()=>{}
      },
      sections: {
        type: Array,
        default: ()=>{}
      },
      sectionsTitle: {
        type: String,
        default: ""
      },
      bigBtn: {
        type: Object,
        default: ()=>{}
      },
      storiesTitle: {
        type: String,
        default: ""
      },
      topText: {
        type: Object,
        default: ()=>{}
      },
      bottomText: {
        type: Object,
        default: ()=>{}
      },
      networkDescription: {
        type: Object,
        default: ()=>{}
      }
    },
    computed: {
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/common';


  /deep/ .container{
    width: 100%;
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
  }

  .bigCall{
    margin-bottom: 20px;
  }

  .flickity-slider,
  .sections{
    display: flex;
    align-items: stretch;
    position: relative;
    z-index: 1;
    @media (max-width:  @bootstrap-md - 1px){
      flex-direction: column;
    }
  }

  .stories,
  .stories /deep/ .flickity-enabled,
  .stories /deep/ .flickity-viewport,
  .stories /deep/ .flickity-slider{
    height: 600px;
  }

  .imageWidgetWrapper /deep/ .carousel-cell:last-child .ImageWidget {
    @media (min-width: @bootstrap-md){
      flex: 0 0 100%;
    }
  }

  .imageWidgetWrapper /deep/ .ImageWidget {
    /*
    flex: ~'1 0 calc(50% - 0px)';
    @media (min-width: @bootstrap-md){
      margin-left: 15px;
      &:first-child{
        flex: ~'1 0 calc(50%)';
        margin-left: 0;
      }
    }

    @media (max-width:  @bootstrap-md - 1px){
      margin-top: 15px;
    }

    */
    @media (min-width: @bootstrap-md){
      margin-left: 15px;
      flex: ~'0 0 calc(100% - 15px)';
      &:first-child{
        margin-left: 0;
        margin-right: 0;
      }
    }

  }

  .sections{
    max-width: 1080px;
    margin: 0 auto;
    @media (max-width: @bootstrap-md - 1px){
      flex-direction: column;
      .imageWidgetWrapper /deep/ .ImageWidget {
        margin-left: 15px;
        margin-right: 15px;
        &:first-child{
          margin-left: 15px;
          margin-right: 15px;
        }
      }
    }
  }

  .sections /deep/ .NetworkSection,
  .stories /deep/ .StoryWidget {
    @media (min-width: @bootstrap-lg){
      flex: ~'1 0 calc(33.33%)';
      margin-left: 15px;
      &:first-child{
        margin-left: 0;
      }
    }
    @media (max-width: @bootstrap-lg - 1px){
      flex-grow: 1;
      flex: ~'1 0 calc(33%)';
      margin-left: 5px;
      &:first-child{
        margin-left: 0;
      }
    }

    @media (max-width: @bootstrap-md - 1px){
      margin-top: 15px;
      margin-left: 0;
    }
  }

  .sectionsWrapper{
    background: #FAFAFA;
    padding-top: 81px;
    position: relative;
    margin-top: 85px;
    z-index: 1;
    &:after{
      content: '';
      z-index: 0;
      position: absolute;
      background: #fff;
      height: 155px;
      width: 100%;
      bottom: 0;
    }
  }
  .sectionsTitle{
    font-size: 36px;
    line-height: 52px;
    margin-bottom: 60px;
    font-weight: 300;
    @media (max-width: @bootstrap-md - 1px){
      font-size: 22px;
      line-height: 30px;
    }
  }

  .bigBtnWrapper{
    max-width: 1254px;
    margin:  0 auto;
    > .container{
      max-width: 1254px;  
    }
  }

  .storiesWrapper{
    margin-top: 95px;
    margin-bottom: 110px;
  }

  .bottomTextWrapper{
    padding-bottom: 80px;
    padding-top: 80px;
  }

  .stories .flickity-slider .carousel-cell{
    width: 360px;
    .StoryWidget{
      margin-right: 15px;
    }
    @media (max-width: @bootstrap-md - 1px){
      width: 95%;
      .StoryWidget {
        width: 95%;
      }
    }
  }

    @media (min-width: @bootstrap-md) and (max-width: @bootstrap-lg - 1px){
      /deep/ .container.noFLK .carousel-cell .StoryWidget{
        max-width: 320px;
      }
      /deep/ .container.noFLK .carousel-cell{
        margin-right: 20px;
      }
      /deep/ .container.noFLK .carousel-cell .StoryWidget{
        width: 320px;
      }
      /deep/ .container.noFLK .carousel-cell .StoryWidget .image{
        width: 100%;
      }
    }


  .container.noFLK{
    @media (max-width: @bootstrap-md - 1px){
      .carousel-cell{
        width: 93%;
        flex: 93% 0 0;
        &:first-child{
          margin-left: 15px;
        }
        .StoryWidget {
          width: 95%;
        }
        .ImageWidget{
          width: 95%;
        }
      }
    }
  }

  .stories{
    @media screen and ( max-width: @bootstrap-md - 1px ) {
      /* disable Flickity for large devices */
      .carousel:after {
        content: '';
      }
    }
  }

  .imageWidgetWrapper .flickity-slider .carousel-cell{
    display: flex;
    width: ~'calc(50vw - 30px)';
    @media (min-width: @bootstrap-xl){
      width: 540px;
    }

    @media (max-width: @bootstrap-md - 1px){
      width: 95%;
      .ImageWidget {
        width: 95%;
        &:first-child{
        }
      }
    }
  }
</style>
